// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgEvBolt2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M14.589 15.429c.002.23.034.457.096.678a.345.345 0 0 1-.117 0c-1.8-.013-3.997-.037-5.965-.037.058-.224.088-.455.089-.686l5.883.045z"
    />
    <path
      fill="currentColor"
      d="M22.094 15.765c-.38.312-1.159.37-1.714.37-.268 0-.484-.02-.573-.02h-.02a2.6 2.6 0 0 0 .1-.686c.685.044 1.542 0 1.761-.2.211-.453.285-.958.213-1.453-.069-.874-.38-1.56-.86-1.903-1.307-.902-8.078-4.673-10.17-4.886-1.937-.192-4.865-.473-6.442.899-2.606 2.287-2.386 6.7-2.105 7.18.216.294.85.363 1.056.363h.051c0 .231.031.462.093.685h-.045a.319.319 0 0 1-.1 0c-.116 0-1.179-.037-1.624-.658-.446-.62-.686-5.513 2.221-8.074C5.757 5.808 8.843 6.113 10.9 6.319c2.235.223 9.123 4.028 10.495 4.992.973.679 1.134 2.02 1.158 2.564.028.666-.078 1.578-.459 1.89z"
    />
    <path
      fill="currentColor"
      d="M8.637 12.282a.343.343 0 0 1-.065-.505l3.096-3.7a.343.343 0 0 1 .394-.092.343.343 0 0 1 .2.343L12 10.426h2.393a.342.342 0 0 1 .305.196.343.343 0 0 1-.048.342l-3.086 3.714a.344.344 0 0 1-.26.123.343.343 0 0 1-.333-.374l.243-2.084h-2.4a.343.343 0 0 1-.178-.06zm.909-.625h2.057a.344.344 0 0 1 .25.113.342.342 0 0 1 .082.264l-.168 1.337 1.9-2.266H11.61a.342.342 0 0 1-.343-.377l.168-1.337zM19.886 15.428a2.6 2.6 0 0 1-.1.686 2.65 2.65 0 0 1-5.204-.686v-.037a2.654 2.654 0 1 1 5.304 0zm-1.653 1.64c.395-.233.696-.597.85-1.03.078-.21.117-.433.117-.658a1.957 1.957 0 0 0-.69-1.474 1.871 1.871 0 0 0-.407-.26 1.958 1.958 0 0 0-2.235.375 1.965 1.965 0 0 0-.58 1.383 1.975 1.975 0 0 0 .576 1.39 1.955 1.955 0 0 0 2.218.37zM8.689 15.363a2.65 2.65 0 1 1-5.3.01 2.654 2.654 0 0 1 5.303 0zm-1.26 1.416c.37-.368.576-.867.577-1.388v-.02a1.965 1.965 0 0 0-3.605-1.069 1.968 1.968 0 0 0 1.64 3.053c.521 0 1.02-.208 1.389-.576z"
    />
  </svg>
);
export default SvgEvBolt2;
